/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ActivityTimelineDto,
    ControlHealthDashboardDto,
    ControlHealthScoreResponseDto,
    ControlId,
    ControlResultId,
    GetControlHealthDashboardParams,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getControlHealthDashboard = (
    params: GetControlHealthDashboardParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlHealthDashboardDto>> => {
    return axios.get(`/api/control-health/dashboard`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetControlHealthDashboardQueryKey = (
    params?: GetControlHealthDashboardParams
) => {
    return [
        `/api/control-health/dashboard`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetControlHealthDashboardQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlHealthDashboardQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlHealthDashboard>>
    > = ({ signal }) =>
        getControlHealthDashboard(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlHealthDashboard>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlHealthDashboardQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlHealthDashboard>>
>;
export type GetControlHealthDashboardQueryError = AxiosError<null>;

export function useGetControlHealthDashboard<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlHealthDashboard>>,
                    TError,
                    Awaited<ReturnType<typeof getControlHealthDashboard>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthDashboard<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlHealthDashboard>>,
                    TError,
                    Awaited<ReturnType<typeof getControlHealthDashboard>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthDashboard<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthDashboard<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlHealthDashboardQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlHealthDashboardSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlHealthDashboardQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlHealthDashboard>>
    > = ({ signal }) =>
        getControlHealthDashboard(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlHealthDashboard>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlHealthDashboardSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlHealthDashboard>>
>;
export type GetControlHealthDashboardSuspenseQueryError = AxiosError<null>;

export function useGetControlHealthDashboardSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthDashboardSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthDashboardSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthDashboardSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthDashboard>>,
    TError = AxiosError<null>,
>(
    params: GetControlHealthDashboardParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthDashboard>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlHealthDashboardSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlHealthControlId = (
    controlId: ControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlHealthScoreResponseDto>> => {
    return axios.get(`/api/control-health/${controlId}`, options);
};

export const getGetControlHealthControlIdQueryKey = (controlId: ControlId) => {
    return [`/api/control-health/${controlId}`] as const;
};

export const getGetControlHealthControlIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlHealthControlIdQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlHealthControlId>>
    > = ({ signal }) =>
        getControlHealthControlId(controlId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: controlId !== null && controlId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlHealthControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlHealthControlIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlHealthControlId>>
>;
export type GetControlHealthControlIdQueryError = AxiosError<null>;

export function useGetControlHealthControlId<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlHealthControlId>>,
                    TError,
                    Awaited<ReturnType<typeof getControlHealthControlId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthControlId<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlHealthControlId>>,
                    TError,
                    Awaited<ReturnType<typeof getControlHealthControlId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthControlId<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthControlId<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlHealthControlIdQueryOptions(
        controlId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlHealthControlIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlHealthControlIdQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlHealthControlId>>
    > = ({ signal }) =>
        getControlHealthControlId(controlId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlHealthControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlHealthControlIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlHealthControlId>>
>;
export type GetControlHealthControlIdSuspenseQueryError = AxiosError<null>;

export function useGetControlHealthControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlHealthControlId>>,
    TError = AxiosError<null>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlHealthControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlHealthControlIdSuspenseQueryOptions(
        controlId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlHealthActivitiesActivityIdTimeline = (
    activityId: ControlResultId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ActivityTimelineDto>> => {
    return axios.get(
        `/api/control-health/activities/${activityId}/timeline`,
        options
    );
};

export const getGetControlHealthActivitiesActivityIdTimelineQueryKey = (
    activityId: ControlResultId
) => {
    return [`/api/control-health/activities/${activityId}/timeline`] as const;
};

export const getGetControlHealthActivitiesActivityIdTimelineQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlHealthActivitiesActivityIdTimelineQueryKey(activityId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>>
    > = ({ signal }) =>
        getControlHealthActivitiesActivityIdTimeline(activityId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: activityId !== null && activityId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlHealthActivitiesActivityIdTimelineQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>>
    >;
export type GetControlHealthActivitiesActivityIdTimelineQueryError =
    AxiosError<null>;

export function useGetControlHealthActivitiesActivityIdTimeline<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlHealthActivitiesActivityIdTimeline
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlHealthActivitiesActivityIdTimeline
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthActivitiesActivityIdTimeline<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlHealthActivitiesActivityIdTimeline
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getControlHealthActivitiesActivityIdTimeline
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthActivitiesActivityIdTimeline<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthActivitiesActivityIdTimeline<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlHealthActivitiesActivityIdTimelineQueryOptions(
            activityId,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlHealthActivitiesActivityIdTimelineSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
        >,
        TError = AxiosError<null>,
    >(
        activityId: ControlResultId,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getControlHealthActivitiesActivityIdTimeline
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetControlHealthActivitiesActivityIdTimelineQueryKey(activityId);

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
            >
        > = ({ signal }) =>
            getControlHealthActivitiesActivityIdTimeline(activityId, {
                signal,
                ...axiosOptions,
            });

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetControlHealthActivitiesActivityIdTimelineSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>>
    >;
export type GetControlHealthActivitiesActivityIdTimelineSuspenseQueryError =
    AxiosError<null>;

export function useGetControlHealthActivitiesActivityIdTimelineSuspense<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthActivitiesActivityIdTimelineSuspense<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlHealthActivitiesActivityIdTimelineSuspense<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlHealthActivitiesActivityIdTimelineSuspense<
    TData = Awaited<
        ReturnType<typeof getControlHealthActivitiesActivityIdTimeline>
    >,
    TError = AxiosError<null>,
>(
    activityId: ControlResultId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getControlHealthActivitiesActivityIdTimeline
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlHealthActivitiesActivityIdTimelineSuspenseQueryOptions(
            activityId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
